import { z } from 'zod';
import { selectionActionFields, selectionRectSchema } from './selection';
import { bilibiliMetadataRequestSchema } from './video-metadata';
const envelope = { channel: z.literal('reados-renderer-v1'), token: z.string().max(128) };
const record = z.record(z.string(), z.unknown());
export const frameMessageSchema = z.discriminatedUnion('type', [
  z.object({ ...envelope, type: z.literal('ready') }).strict(),
  z.object({ ...envelope, type: z.literal('rendered'), messageCount: z.number().int().nonnegative() }).strict(),
  z.object({ ...envelope, type: z.literal('scrollState'), scope: z.string().min(1).max(4096), canScrollToBottom: z.boolean() }).strict(),
  z.object({ ...envelope, type: z.literal('error'), message: z.string().max(4000) }).strict(),
  z.object({ ...envelope, type: z.literal('request'), id: z.string().max(128), kind: z.enum(['resolve', 'resolvePayload', 'videoFrame', 'videoMetadata']), value: record }).strict()
    .refine(message => message.kind !== 'videoMetadata' || bilibiliMetadataRequestSchema.safeParse(message.value).success),
  z.object({ ...envelope, type: z.literal('cancelRequest'), id: z.string().max(128) }).strict(),
  z.object({ ...envelope, type: z.literal('navigate'), href: z.string().max(8192).optional(), payload: record.optional() }).strict(),
  z.object({ ...envelope, type: z.literal('openUrl'), url: z.string().max(8192) }).strict(),
  z.object({ ...envelope, type: z.literal('openImages'),
    items: z.array(z.object({ source: z.string().min(1).max(1_000_000), title: z.string().max(1024).optional() }).strict()).min(1).max(64),
    index: z.number().int().min(0).max(63), requestId: z.string().min(1).max(128),
  }).strict(),
  z.object({ ...envelope, type: z.literal('followUp'), text: z.string().min(1).max(32000) }).strict(),
  z.object({ ...envelope, type: z.literal('openAgent'), threadId: z.string().min(1).max(128) }).strict(),
  z.object({ ...envelope, type: z.literal('copy'), text: z.string().max(2_000_000) }).strict(),
  z.object({ ...envelope, type: z.literal('fork'), scope: z.string().min(1).max(4096), messageID: z.string().min(1).max(1024) }).strict(),
  z.object({ ...envelope, type: z.literal('selectionAction'), ...selectionActionFields }).strict(),
  z.object({ ...envelope, type: z.literal('selectionAnchor'), id: z.string().min(1).max(128), rect: selectionRectSchema.nullable() }).strict(),
  z.object({ ...envelope, type: z.literal('state'), key: z.string().max(4096), value: z.unknown(), stateKind: z.enum(['state', 'failureOutcome']) }).strict(),
]);

export function parseFrameMessage(value: unknown) {
  try { if (JSON.stringify(value).length > 2_100_000) return null; } catch { return null; }
  const result = frameMessageSchema.safeParse(value);
  if (!result.success) return null;
  if (result.data.type === 'openImages' && result.data.index >= result.data.items.length) return null;
  return result.data;
}
